import { useState, useEffect } from 'react';
import moment from 'moment';

const FIVE_MINUTES = 5 * 60 * 1000;

const FromNow = ({ value }) => {
  const [label, setLabel] = useState(() => moment(value).fromNow());

  useEffect(() => {
    setLabel(moment(value).fromNow());
    const interval = setInterval(() => {
      setLabel(moment(value).fromNow());
    }, FIVE_MINUTES);
    return () => clearInterval(interval);
  }, [value]);

  return label;
};

export default FromNow;
